import generateVehicleParams from './generateVehicleParams'

const generateProductUrl = ({ product, modifiers }) => {
  const vehicleParams = generateVehicleParams(modifiers)
 const url = `/details${product.url}`

  if (vehicleParams) {
    return `${url}?${vehicleParams}`
  }

  return url
}

export default generateProductUrl
